import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { authReducer, newsReducer, uiReducer } from './slices';

// Создаем хранилище Redux
export const store = configureStore({
  reducer: {
    // Обычные редьюсеры
    auth: authReducer,
    news: newsReducer,
    ui: uiReducer,
  },
  
  // Включаем Redux DevTools в development-режиме
  devTools: process.env.NODE_ENV !== 'production',
  
  // Добавляем middleware
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Игнорируем эти типы экшенов
        ignoredActions: ['ui/addNotification'],
      },
    }),
});

// Настраиваем слушатели для refetchOnFocus/refetchOnReconnect
setupListeners(store.dispatch);

// Типы для TypeScript
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Типизированные хуки для использования в приложении
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;